<template>
  <div class="menu-block">
    <b-btn
      v-if="notifications.energydata.total > 0"
      v-b-tooltip.hover.bottom
      :title="
        'Stiahnuté dáta dnes: ' +
        notifications.energydata.today +
        '\n z celkových: ' +
        notifications.energydata.total
      "
      :to="{ name: 'apiLogs' }"
      class="faded"
    >
      <b-icon
        :icon="
          notifications.energydata.today ? 'calendar2-check' : 'calendar2-x'
        "
        scale="1.5x"
      />
      <span
        :class="{
          'badge-warning':
            notifications.energydata.today < notifications.energydata.total,
          'badge-success':
            notifications.energydata.today >= notifications.energydata.total,
        }"
        class="badge"
      >
        <template v-if="notifications.energydata.today > 99">99+</template>
        <template v-else>{{ notifications.energydata.today }}</template>
      </span>
    </b-btn>
    <b-dropdown
      v-if="notifications.api"
      menu-class="dropdown-menu-animated"
      no-caret
      right
      @shown="$vuebar.refreshScrollbar($refs.scroll, {})"
    >
      <template slot="button-content">
        <b-icon icon="bell" scale="1.5x" />
        <b-badge
          v-if="notifications.api.count"
          class="font-weight-bold"
          variant="danger"
        >
          <template v-if="notifications.api.count > 99"> 99+ </template>
          <template v-else>
            {{ notifications.api.count }}
          </template>
        </b-badge>
      </template>
      <div role="group">
        <div ref="scroll" v-bar style="max-height: 310px">
          <div>
            <b-dropdown-item-button
              v-for="notification in notifications.api.data"
              :key="notification.id"
              @click.prevent="markAsRead(notification.id)"
            >
              <div class="d-flex">
                <template
                  v-if="notification.type === 'App\\Notifications\\OverPower'"
                >
                  <div class="pr-2 align-self-center" style="width: 35px">
                    <icon
                      class="icon-fw text-power"
                      name="regular/caret-square-up"
                      scale="1.5"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      {{ notification.typeNumber }}
                    </div>
                    <div class>
                      <div
                        v-if="
                          notification.data.overflows &&
                          notification.data.overflows.mrk > 0
                        "
                      >
                        Prekročenie MRK:
                        <span class="font-weight-bold">{{
                          notification.data.overflows.mrk
                        }}</span
                        >x
                      </div>
                      <div
                        v-if="
                          notification.data.overflows &&
                          notification.data.overflows.rk > 0
                        "
                      >
                        Prekročenie RK:
                        <span class="font-weight-bold">{{
                          notification.data.overflows.rk
                        }}</span
                        >x
                      </div>
                    </div>
                    <div class="fs-sm text-muted">
                      {{ notification.created_at | formatAgo }}
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    notification.type === 'App\\Notifications\\NearOverPower'
                  "
                >
                  <div class="pr-2 align-self-center" style="width: 35px">
                    <icon
                      class="icon-fw text-power"
                      name="percentage"
                      scale="1.5"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      {{ notification.typeNumber }}
                    </div>
                    <div class>Dosiahnuté 85% RK</div>
                    <div class="fs-sm text-muted">
                      {{ notification.created_at | formatAgo }}
                    </div>
                  </div>
                </template>
                <template
                  v-if="notification.type === 'App\\Notifications\\OverGas'"
                >
                  <div class="pr-2 align-self-center" style="width: 35px">
                    <icon
                      class="icon-fw text-gas"
                      name="regular/caret-square-up"
                      scale="1.5"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      {{ notification.typeNumber }}
                    </div>
                    <div class>
                      <div v-if="notification.data.overLimitOver110percent > 0">
                        Prekročenie hranice 110% o:
                        <span class="font-weight-bold"
                          >{{
                            notification.data.overLimitOver110percent
                              | formatNumber(2)
                          }}
                          m3</span
                        >
                      </div>
                      <div
                        v-if="notification.data.overLimit105to110percent > 0"
                      >
                        Prekročenie hranice 105% o:
                        <span class="font-weight-bold"
                          >{{
                            notification.data.overLimit105to110percent
                              | formatNumber(2)
                          }}
                          m3</span
                        >
                      </div>
                    </div>
                    <div class="fs-sm text-muted">
                      {{ notification.created_at | formatAgo }}
                    </div>
                  </div>
                </template>
                <template
                  v-if="notification.type === 'App\\Notifications\\NearOverGas'"
                >
                  <div class="pr-2 align-self-center" style="width: 35px">
                    <icon
                      class="icon-fw text-gas"
                      name="percentage"
                      scale="1.5"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      {{ notification.typeNumber }}
                    </div>
                    <div class>Dosiahnuté 85% odberu</div>
                    <div class="fs-sm text-muted">
                      {{ notification.created_at | formatAgo }}
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    notification.type === 'App\\Notifications\\UploadOperation'
                  "
                >
                  <div class="pr-2 align-self-center" style="width: 35px">
                    <icon
                      class="icon-fw text-power"
                      name="sort-numeric-up"
                      scale="1.5"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">
                      {{ notification.typeNumber }}
                    </div>
                    <div class>Nahrajte meranú spotrebu</div>
                    <div class="fs-sm text-muted">
                      {{ notification.created_at | formatAgo }}
                    </div>
                  </div>
                </template>
              </div>
            </b-dropdown-item-button>
          </div>
        </div>
      </div>
      <div role="group">
        <b-dropdown-item
          :to="{ name: 'notifications' }"
          active-class
          class="px-3 text-center font-weight-bold"
          exact-active-class
        >
          <icon class="mr-1" name="bars" />
          Zobraziť všetky
        </b-dropdown-item>
      </div>
    </b-dropdown>
    <b-btn
      v-if="$root.user.isAdmin || $root.userData.company_id == 10"
      v-b-tooltip.hover.bottom
      class="faded"
      href="https://audit.d-fs.sk/"
      target="_blank"
      title="Prejsť na DFS Audit"
    >
      <b-icon icon="box-arrow-up-right" scale="1.5x" />
    </b-btn>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  created() {
    this.$store.dispatch('user/fetchNotifications')
    setInterval(() => {
      this.$store.dispatch('user/fetchNotifications')
    }, 60000)
  },
  methods: {
    markAsRead(id) {
      this.$api
        .post('notifications/mark_as_read', {
          id: id,
        })
        .then(() => {
          this.$router.push({ name: 'notifications' })

          this.$store.dispatch('user/fetchNotifications')
        })
    },
  },
  computed: {
    ...mapState({
      notifications: (state) => state.user.notifications,
    }),
  },
}
</script>
